/**
 * PV EA Product Grid
 * Quantity stepper on each card: a round "+" that opens into the − n + pill
 * (card gets .is-selected); − at the first tier closes it back to "+". The
 * add-to-cart button always adds the tier shown. The card's quantity tiers come from
 * <script data-pv-ea-pgrid-tiers> (one entry per variant titled with a unit
 * count, priced in Liquid — see the tier comment in the section). − / + move
 * between the counts that have a tier (today 1, 2, 4; 3/5/6 appear once those
 * variants exist) and swap the badge %, compare-at, price and fine print, and
 * point the add-to-cart button at that tier's variant + selling plan
 * (quantity 1), plus the optional $0 free-jar line ([data-free-variant]).
 * The add to cart itself is pv-early-access-cart.js. Tier prices switch to the
 * Froya campaign first-order price when one is running (pv-ea-campaign.js).
 * Without tier data the stepper falls back to a plain 1..max quantity.
 */

(function () {
  'use strict';

  function readTiers(card) {
    var el = card.querySelector('[data-pv-ea-pgrid-tiers]');
    if (!el) return [];
    try {
      var tiers = JSON.parse(el.textContent);
      return Array.isArray(tiers)
        ? tiers.filter(function (t) { return t && t.units > 0 && t.id; })
               .sort(function (a, b) { return a.units - b.units; })
        : [];
    } catch (e) {
      return [];
    }
  }

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  function initCard(card) {
    var stepper = card.querySelector('[data-pv-ea-pgrid-stepper]');
    var atc = card.querySelector('[data-pv-ea-atc]');
    if (!stepper || !atc) return;

    var add = card.querySelector('[data-pv-ea-pgrid-add]');
    var dec = stepper.querySelector('[data-pv-ea-pgrid-dec]');
    var inc = stepper.querySelector('[data-pv-ea-pgrid-inc]');
    var out = stepper.querySelector('[data-pv-ea-pgrid-qty]');
    var badge = card.querySelector('[data-pv-ea-pgrid-badge]');
    var compare = card.querySelector('[data-pv-ea-pgrid-compare]');
    var price = card.querySelector('[data-pv-ea-pgrid-price]');
    var fine = card.querySelector('[data-pv-ea-pgrid-fine]');
    var tiers = readTiers(card);
    var max = parseInt(stepper.dataset.max, 10) || 1;
    var freeVariant = Number(card.dataset.freeVariant) || 0;

    // Plain stepper when the card has no tier data.
    if (!tiers.length) {
      tiers = [];
      for (var n = 1; n <= max; n++) tiers.push({ units: n });
    }
    var index = 0;
    var open = !add;

    function render() {
      var t = tiers[index];
      setText(out, String(t.units));
      if (add) {
        add.hidden = open;
        stepper.hidden = !open;
        card.classList.toggle('is-selected', open);
      } else if (dec) {
        dec.disabled = index <= 0;
      }
      if (inc) inc.disabled = index >= tiers.length - 1;

      if (!t.id) {
        atc.dataset.quantity = String(t.units);
        return;
      }

      atc.dataset.variantId = String(t.id);
      atc.dataset.quantity = '1';
      if (t.plan) {
        atc.dataset.sellingPlan = String(t.plan);
      } else {
        delete atc.dataset.sellingPlan;
      }
      // Free jar: a separate $0 line in the same request (data-items wins
      // over data-variant-id in pv-early-access-cart.js).
      if (freeVariant) {
        var paid = { id: Number(t.id), quantity: 1 };
        if (t.plan) paid.selling_plan = Number(t.plan);
        atc.dataset.items = JSON.stringify([paid, { id: freeVariant, quantity: 1 }]);
      }

      setText(price, t.price);
      if (compare) {
        setText(compare, t.compare);
        compare.parentElement.hidden = !t.compare;
      }
      if (badge) {
        setText(badge, t.pct ? t.pct + (badge.dataset.suffix || '') : '');
        badge.hidden = !t.pct;
      }
      if (fine && t.fine) setText(fine, t.fine);
    }

    // Campaign prices (Froya engine, see pv-ea-campaign.js): each tier's price
    // becomes its first-order campaign price and its badge % is recomputed
    // against the same compare-at (rounded, like the Liquid). Renewal fine
    // print stays Loop's. No campaign price: the tier's Liquid values.
    if (window.PVEaCampaign && card.dataset.handle) {
      var originals = tiers.map(function (t) {
        return { price: t.price, pct: t.pct };
      });
      PVEaCampaign.watch(function () {
        Promise.all(
          tiers.map(function (t) {
            if (!t.id) return null;
            return PVEaCampaign.price(t.id, card.dataset.handle, t.plan ? 'sub' : 'otp');
          })
        ).then(function (prices) {
          prices.forEach(function (now, i) {
            var t = tiers[i];
            if (now == null || !t.id) {
              t.price = originals[i].price;
              t.pct = originals[i].pct;
              return;
            }
            t.price = PVEaCampaign.money(now, true);
            t.pct = t.compareCents > now ? String(Math.round(((t.compareCents - now) * 100) / t.compareCents)) : '';
          });
          render();
        });
      });
    }

    if (add) {
      add.addEventListener('click', function () {
        open = true;
        render();
        // The "+" is gone: keep keyboard focus on the pill.
        if (inc && !inc.disabled) inc.focus();
        else if (dec) dec.focus();
      });
    }

    if (dec) {
      dec.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
        } else if (add) {
          open = false;
          render();
          add.focus();
          return;
        }
        render();
      });
    }

    if (inc) {
      inc.addEventListener('click', function () {
        if (index < tiers.length - 1) index += 1;
        render();
      });
    }

    render();
  }

  function init(root) {
    if (!root || root.dataset.pvEaPgridReady) return;
    root.dataset.pvEaPgridReady = 'true';
    root.querySelectorAll('[data-pv-ea-pgrid-card]').forEach(initCard);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pv-ea-pgrid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
